export const assertNonNegativeInteger = (value: number, name: string): void => {
  if (!Number.isFinite(value) || !Number.isInteger(value) || value < 0) {
    throw new RangeError(`${name} must be a finite non-negative integer.`);
  }
};

export const assertUint32 = (value: number, name: string): void => {
  assertNonNegativeInteger(value, name);
  if (value > 0xffff_ffff) throw new RangeError(`${name} must fit in an unsigned 32-bit integer.`);
};
